/**
 * This file exports the firebase configuration object that
 * informs firebase about what backend services to use. The
 * object is consumed in index.ts.
 *
 * The values for the configuration object is populated through
 * the .env files in the root, using the npm package dotenv-webpack.
 * The values depends on what  environment the app is in (i.e.
 * staging, development, production). For instance we can use
 * different backend databases for staging and production.
 *
 * The repos' main README.md guides you on how to obtain and
 * specify different values for each environment. The docs has
 * more on how the .env setup works behind the curtain.
 */
export const config = {
  apiKey: process.env.apiKey,
  authDomain: process.env.authDomain,
  databaseURL: process.env.databaseURL,
  projectId: process.env.projectId,
  storageBucket: process.env.storageBucket,
  messagingSenderId: process.env.messagingSenderId,
}
